import React, { Component } from "react";
import { connect } from "react-redux";
import Contact from "../Component/contact";

import { AddContactForm1 } from "../../../Client/action";

export class Controller extends Component {
  render() {
    return <Contact {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    login: store.login,
    loader: store.loader,
    snackbar: store.snackbar,
    client: store.client,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    AddContactForm1: (firstName, lastName, email, mobile, address) => {
      dispatch(AddContactForm1(firstName, lastName, email, mobile, address));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
